import { getEmployeeFullName } from '../../../../util/table.util'

// Helper function to get initials from employee name
export const getEmployeeInitials = (employee) => {
  const fullName = getEmployeeFullName(employee)
  if (!fullName) return '?'

  const names = fullName.trim().split(' ')
  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase()
  }
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase()
}

// Helper function to format full address from components
export const formatAddress = (employee) => {
  const addressParts = []

  if (employee.streetAddress) {
    addressParts.push(employee.streetAddress)
  }
  if (employee.city) {
    addressParts.push(employee.city)
  }
  if (employee.state) {
    addressParts.push(employee.state)
  }
  if (employee.postalCode) {
    addressParts.push(employee.postalCode)
  }

  return addressParts.length > 0 ? addressParts.join(', ') : null
}

// Helper function to format last active date
export const formatLastActive = (employee) => {
  // Helper to calculate days ago from a date
  const calculateDaysAgo = (dateValue) => {
    const date = new Date(dateValue)
    if (Number.isNaN(date.getTime())) {
      return null
    }

    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const activityDate = new Date(date)
    activityDate.setHours(0, 0, 0, 0)

    const diffDays = Math.floor((today - activityDate) / (1000 * 60 * 60 * 24))

    if (diffDays === 0) {
      return 'Today'
    }
    if (diffDays === 1) {
      return '1d ago'
    }
    return `${diffDays}d ago`
  }

  // Check if we have a pre-calculated lastActive
  if (employee.lastActive) {
    // If it's already a formatted string (like "2d ago", "Today", "Never"), return it
    if (typeof employee.lastActive === 'string') {
      // Check if it looks like a formatted string (contains "ago", "Today", or "Never")
      if (employee.lastActive.includes('ago') || employee.lastActive === 'Today' || employee.lastActive === 'Never') {
        return employee.lastActive
      }
      // Otherwise, try to parse it as a date
      const formatted = calculateDaysAgo(employee.lastActive)
      if (formatted) {
        return formatted
      }
      // If parsing fails, return the string as-is (might be a formatted string we don't recognize)
      return employee.lastActive
    }
    // If it's a Date object, format it
    if (employee.lastActive instanceof Date) {
      return calculateDaysAgo(employee.lastActive) || 'Never'
    }
  }

  // Check lastSignInDate
  if (employee.lastSignInDate) {
    const formatted = calculateDaysAgo(employee.lastSignInDate)
    if (formatted) {
      return formatted
    }
  }

  // No activity data available
  return 'Never'
}

// Alignment configuration for pill and text content
export const CONTENT_MARGINS = {
  CUSTOM_PILL: '-14px', // Gray background pills (User type)
  CUSTOM_PILL_FIRST: '-15px', // First pill in multi-pill rows (Roles, Groups, Licenses)
  BADGE_PILL: '-12px', // Outlined badge pills (Sign-in status, Allowed)
  BADGE_PILL_WARNING: '-14px', // Warning badge pills (Mailbox rules)
  PLAIN_TEXT: '-4px', // Plain text values (Password policies, Created)
}

// Tab configuration
export const TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'userproperties', label: 'User properties' },
]
